import { DTO, Nullable } from '@/type-utils';
import { isNullOrEmpty } from '@/utils/null-utils';
import Model from '../../Model';

import type IProfile from './IProfile';

/** Represents a Profile, a collection of a customer's personal information. */
export default class ProfileModel
  extends Model<DTO<IProfile>>
  implements IProfile
{
  /** @inheritdoc */
  public readonly accountID: string;

  /** @inheritdoc */
  public readonly firstName: string;

  /** @inheritdoc */
  public readonly lastName: string;

  /** @inheritdoc */
  public readonly email: string;

  /** @inheritdoc */
  public readonly birthday: Nullable<Date>;

  /** @inheritdoc */
  public readonly phoneNumber?: Nullable<string>;

  /** @inheritdoc */
  public readonly preferredWallet?: Nullable<string>;

  /** @inheritdoc */
  public readonly preferredAddress?: Nullable<string> = null;

  /** @inheritdoc */
  public constructor(dto: DTO<IProfile>) {
    super(dto);

    this.accountID = dto.accountID;
    this.firstName = dto.firstName;
    this.lastName = dto.lastName;
    this.email = dto.email;
    this.birthday = !isNullOrEmpty(dto.birthday)
      ? new Date(dto.birthday)
      : null;
    this.phoneNumber = dto.phoneNumber;
    this.preferredWallet = dto.preferredWallet;
    this.preferredAddress = dto.preferredAddress ?? null;
  }

  /** @inheritdoc */
  public toDTO(): DTO<IProfile> {
    return {
      accountID: this.accountID,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      birthday: this.birthday?.toJSON(),
      phoneNumber: this.phoneNumber,
      preferredWallet: this.preferredWallet,
      preferredAddress: this.preferredAddress
    };
  }
}
